/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import emmaLogo from './../../../assets/images/emma-logo.png';
import { configActions } from '../../../features/Config/ConfigSlice';
import NavLeft from './NavLeft';
import NavRight from './NavRight';

const NavBar = () => {
  const dispatch = useDispatch();
  const { collapseMenu, headerFixedLayout, layout, subLayout } = useSelector(
    (state) => state.config
  );
  const [moreToggle, setMoreToggle] = useState(false);

  let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg', 'header-indigogreen'];
  if (headerFixedLayout && layout === 'vertical') {
    headerClass = [...headerClass, 'headerpos-fixed'];
  }

  let toggleClass = ['mobile-menu'];
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  const navToggleHandler = () => {
    dispatch(configActions.update({ type: 'COLLAPSE_MENU' }));
  };

  let moreClass = ['mob-toggler'];
  let collapseClass = ['collapse navbar-collapse'];
  if (moreToggle) {
    moreClass = [...moreClass, 'on'];
    collapseClass = [...collapseClass, 'd-block'];
  }

  let navBar = (
    <React.Fragment>
      <div className="m-header">
        <span className="header-icon">
          <img src={emmaLogo} alt="" />
        </span>
        <Link
          to="#"
          className={toggleClass.join(' ')}
          id="mobile-collapse"
          onClick={() => navToggleHandler()}
          style={{
            cursor: 'pointer'
          }}
        >
          <span />
        </Link>

        <Link to="#" className={moreClass.join(' ')} onClick={() => setMoreToggle(!moreToggle)}>
          <i className="feather icon-more-vertical" />
        </Link>
      </div>
      <div className={collapseClass.join(' ')}>
        <NavLeft />
        <NavRight />
      </div>
    </React.Fragment>
  );

  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBar = <div className="container">{navBar}</div>;
  }

  return (
    <React.Fragment>
      <header className={headerClass.join(' ')}>{navBar}</header>
    </React.Fragment>
  );
};

export default NavBar;
